import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import moment from 'moment';

class ReportIssue extends Component {

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
  }

  render() {

    return (
      <div className="animated fadeIn" style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
        <h4>Truy cập vào <a href="http://bit.ly/houselink-issue" target="_blank">đây</a> để báo bug cho developer </h4>
      </div>
    );
  }
}

export default ReportIssue;


// WEBPACK FOOTER //
// ./src/views/Dashboard/ReportIssue.js